import type { AppSaveBarProps } from "./app-save-bar.type";

import { useTranslation } from "react-i18next";

import { RouterBlocker } from "@/modules/router-blocker";
import { SaveBar } from "@/ui/save-bar";

import { useAppSaveBarInit } from "./app-save-bar.hook";

export const AppSaveBar = (props: AppSaveBarProps) => {
  const { t } = useTranslation();
  const {
    showSaveBar,
    date,
    loading,
    hasChanges,
    onSave,
    onCancel,
    shouldBlock,
    shouldShowModal,
  } = useAppSaveBarInit(props);

  if (!showSaveBar) return null;

  return (
    <>
      <RouterBlocker
        shouldBlock={shouldBlock}
        shouldShowModal={shouldShowModal}
        title={t("global:leavePage")}
        message={t("global:unsavedChanges")}
        onConfirm={onCancel}
      />
      <SaveBar
        loading={loading}
        hasChanges={hasChanges}
        date={date}
        onSave={onSave}
        onCancel={onCancel}
      />
    </>
  );
};
